import React from 'react';
import PropTypes from 'prop-types';

const ThreadSectionCollapseContext = React.createContext(undefined);

const ThreadSectionCollapseProvider = ({
  children,
  initialState,
}) => {
  const [collapsed, setCollapsed] = React.useState(initialState);

  const memoizedValue = React.useMemo(() => {
    return {
      collapsed,
      setCollapsed,
    };
  }, [
    collapsed,
    setCollapsed,
  ]);

  return (
    <ThreadSectionCollapseContext.Provider value={memoizedValue}>
      {children}
    </ThreadSectionCollapseContext.Provider>
  );
};

// Use Collapse State Context
const useThreadSectionCollapseContext = () => {
  const context = React.useContext(ThreadSectionCollapseContext);
  if (context === undefined) {
    throw new Error('useThreadSectionCollapseContext must be used within a ThreadSectionCollapseProvider');
  }
  return context;
};

ThreadSectionCollapseProvider.defaultProps = {
  initialState: false,
};

ThreadSectionCollapseProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.bool,
};

export {
  ThreadSectionCollapseProvider,
  useThreadSectionCollapseContext,
};
